export default class Consumables {
  constructor(api) {
    this.api = api;
  }
  getAll(queryParams, fields, onSuccess, onError) {
    if (fields != "") {
      fields = "&include=" + fields;
    }
    let params = "";
    if (queryParams) {
      for (const [query, value] of Object.entries(queryParams)) {
        params += params === "" ? "?" : "&";
        params += query + "=" + value;
      }
    }
    return this.api.http_fibercloud
      .get("v1/consumable-apis/list?paginate=false" + params + fields, {
      })
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }
  getConsumables(onSuccess, onError) {
    return this.api.http_fibercloud
      .get("v1/consumable-apis/list?paginate=false")
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }
  getConsumablesWMS(onSuccess, onError) {
    return this.api.http_fibercloud
      .get("v1/consumable-apis/list?paginate=false&filter[type]=WMS&filter[active]=true")
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  getConsumablesById(consumablesId, onSuccess, onError) {
    return this.api.http_fibercloud
      .get("v1/consumable-apis/" + consumablesId )
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  editConsumables(data, onSuccess, onError) {
    return this.api.http_fibercloud
      .put("v1/consumable-apis/" + data.id, data)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  createConsumables(data, onSuccess, onError) {
    return this.api.http_fibercloud
      .post("v1/consumable-apis/new", data)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  deleteConsumables(consumableID, onSuccess, onError) {
    return this.api.http_fibercloud
      .delete("v1/consumable-apis/" + consumableID)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  downloadAll(onSuccess, onError) {
    return this.api.http_fibercloud
      .get("v1/consumable-apis/export/excel")
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }
}



// WEBPACK FOOTER //
// ./src/api/consumables.js